import React from 'react';

const EditIcon: React.FC<{ width?: string; height?: string; fill?: string }> = ({
  width = '14px',
  height = '15px',
  fill = '#FFF',
}): React.ReactElement => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.000156123 14.5005L4.02183 13.5724L13.9213 3.67292L13.612 2.12612L12.3745 0.888685L10.8277 0.579325L0.928234 10.4788L0.000156123 14.5005ZM11.7561 4.60131L4.85759 11.4998L3.00143 9.64369L9.89996 2.74516L11.7561 4.60131ZM12.3748 3.9826L13.0461 3.31129L12.7368 2.4884L12.0126 1.76419L11.1903 1.45483L10.5187 2.12644L12.3748 3.9826ZM2.38272 10.2624L4.23887 12.1186L3.58099 12.7764L1.16737 13.3333L1.72421 10.9209L2.38272 10.2624Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default EditIcon;
